import Sidebar from './Sidebar'
import { Box, createTheme, Stack, ThemeProvider } from '@mui/material'
import Navbar from './Navbar'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { useColorScheme } from '@mui/material/styles'
import { updateSideBarSelected } from '../store/actions/modeAction'

function Layout({ children }) {
    const navigate = useNavigate()
    const location = useLocation() // Hook to get the current URL
    const dispatch = useDispatch()
    const { mode, setMode } = useColorScheme()
    const { userInfo } = useSelector((state) => state.auth)
    // const { mode } = useSelector((state) => state.mode)
    useEffect(() => {
        if (!userInfo) {
            navigate('/login')
        }
    }, [userInfo, navigate])

    useEffect(() => {
        if (location.pathname === '/') {
            dispatch(updateSideBarSelected(0))
        }
    }, [dispatch, location.pathname])

    const darkTheme = createTheme({
        palette: {
            mode: mode,
        },
    })
    return (
        <ThemeProvider theme={darkTheme}>
            <Box bgcolor={'background.default'} color={'text.primary'}>
                <Navbar />
                <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="space-between"
                    minHeight="95vh"
                >
                    <Sidebar
                        mode={mode}
                        setMode={setMode}
                        userInfo={userInfo}
                    />
                    <Box flex={4} p={{ xs: 0, md: 2 }}>
                        {children}
                    </Box>
                    {/* <Rightbar /> */}
                </Stack>
            </Box>
        </ThemeProvider>
    )
}

export default Layout
